export default __webpack_public_path__ + "static/media/Trash  Active - Hover.7cd41a23.svg";